import { render, staticRenderFns } from "./Triforce.vue?vue&type=template&id=33e8e25d&scoped=true&"
import script from "./Triforce.vue?vue&type=script&lang=js&"
export * from "./Triforce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8e25d",
  null
  
)

export default component.exports